import { ChangeDetectionStrategy, Component, computed, contentChildren, effect, input, output } from '@angular/core';

import { BaasTile } from '../baas-tile/baas-tile';
import { BaasTileGroup } from '../baas-tile-group/baas-tile-group';
import { BaasTileOptions } from '../baas-tile-options.type';

@Component({
    selector: 'baas-tile-list',
    templateUrl: './baas-tile-list.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasTileGroup, BaasTile]
})
export class BaasTileList {
    readonly tiles = input<BaasTileOptions[]>();
    readonly group = input(true);
    readonly favorite = output<boolean | { id: number | string; value: boolean }>();
    readonly contentGroups = contentChildren(BaasTileGroup);

    protected readonly tileGroups = computed(() => {
        const tileGroups: BaasTileOptions[][] = [];
        if (this.tiles() && this.tiles().length) {
            let currentGroup: BaasTileOptions[] = null;

            this.tiles().forEach((tile) => {
                if (!currentGroup || tile.initiator) {
                    currentGroup = [];
                    tileGroups.push(currentGroup);
                }

                currentGroup.push(tile);
            });
        }
        return tileGroups;
    });

    constructor() {
        effect(() => {
            if (this.contentGroups()) {
                this.contentGroups().forEach((group) => group.favorite.subscribe((data) => this.favoriteClicked(data)));
            }
        });
    }

    protected favoriteClicked(event) {
        this.favorite.emit(event);
    }
}
